__turbopack_context__.v({
  "afb__author": "DealsPageBooks-module__rPgXNa__afb__author",
  "afb__title": "DealsPageBooks-module__rPgXNa__afb__title",
  "deals-dlp": "DealsPageBooks-module__rPgXNa__deals-dlp",
  "deals-dlp-salePrice": "DealsPageBooks-module__rPgXNa__deals-dlp-salePrice",
  "deals-sale": "DealsPageBooks-module__rPgXNa__deals-sale",
  "deals_page__dollar_sign": "DealsPageBooks-module__rPgXNa__deals_page__dollar_sign",
  "dealspage__book": "DealsPageBooks-module__rPgXNa__dealspage__book",
  "dealspage__book__on-sale-now": "DealsPageBooks-module__rPgXNa__dealspage__book__on-sale-now",
  "dealspage__book_detail": "DealsPageBooks-module__rPgXNa__dealspage__book_detail",
  "dealspage__bookcontent": "DealsPageBooks-module__rPgXNa__dealspage__bookcontent",
  "dealspage__saleprice_text": "DealsPageBooks-module__rPgXNa__dealspage__saleprice_text",
  "dealspage_book_read_more_link": "DealsPageBooks-module__rPgXNa__dealspage_book_read_more_link",
  "sale_price": "DealsPageBooks-module__rPgXNa__sale_price",
});
